export default "__VITE_ASSET__wXtssIy___"